/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function StarFour(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M158.72416,163.50856l-23.20581,63.816a8,8,0,0,1-15.0367,0l-23.20581-63.816a8,8,0,0,0-4.7844-4.7844l-63.816-23.20581a8,8,0,0,1,0-15.0367l63.816-23.20581a8,8,0,0,0,4.7844-4.7844l23.20581-63.816a8,8,0,0,1,15.0367,0l23.20581,63.816a8,8,0,0,0,4.7844,4.7844l63.816,23.20581a8,8,0,0,1,0,15.0367l-63.816,23.20581A8,8,0,0,0,158.72416,163.50856Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default StarFour;
